var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-icon",style:(_vm.svg)})
}
var staticRenderFns = []

export { render, staticRenderFns }